import { createContext } from "react";

export type IOpenExcursionContext = {
  openExcursions: string[];
  addOpenExcursion: (excursionId: string) => void;
  closeUppermostExcursion: () => void;
} | null;

export const OpenExcursionContext = createContext<IOpenExcursionContext>(null);
